// extracted by mini-css-extract-plugin
export var card = "_v5-0";
export var details = "_v5-1";